// extracted by mini-css-extract-plugin
export var transportationTablesCol = "ae47aee99a4ce08cf44b119632890ed5-css";